<template>
  <section class="catg-area ptop-5 section-header" v-if="jdSelectors">
    <div class="container">
      <div class="filer-section d-flex ms-2" style="gap: 40px;">
        <label class="dark-gray font-bold">絞り込み条件の詳細設定</label>
        <div class="d-flex align-items-center" style="gap: 10px;">
          <p 
            @click="toggleFilterForm" 
            style="cursor: pointer;"
            :class="hasActiveSearch ? 'ai-settings-active' : ''"
          >
            {{ hasActiveSearch ? '選択中' : '＋　選択' }}
          </p>
          <span 
            v-if="hasActiveSearch"
            @click="clearAllSearches"
            style="cursor: pointer;"
            class="clear-search-btn mb-2"
          >
            × クリア
          </span>
        </div>
      </div>

      <b-modal
        ref="filterForm"
        id="search-form-modal"
        title="絞り込み条件の詳細設定"
        size="lg"
        hide-footer
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
        @hide="hideModal"
      >
        <form ref="form" @submit.prevent="handleSearch">
          <div class="custom-form-block">
            <div class="form-group row">
              <h3 class="col-md-2 col-form-label">登録/更新日</h3>
              <div class="col-md-2">
                <select class="form-control" v-model="selectedDateRange">
                  <option value=""></option>
                  <option value="1week">直近1週間</option>
                  <option value="2weeks">直近2週間</option>
                  <option value="1month">直近1ヶ月</option>
                  <option value="2months">直近2ヶ月</option>
                </select>
              </div>
            </div>
            <div class="form-group row align-items-center">
              <h3 class="col-md-2 col-form-label">年齢</h3>
              <div class="col-md-5">
                <div class="form-check form-check-inline">
                  <div class="col-xs-4 d-flex flex-column">
                    <div class="d-flex" style="align-items:flex-end">
                      <input
                        type="number"
                        class="form-control ageInc-field"
                        v-model="fromAgeModel"
                        min="0"
                        v-bind:class="{
                          'is-invalid': errors.fromAgeModel.error,
                        }"
                      />
                      <span class="age-text">歳</span>
                    </div>
                    <div
                      class="invalid-feedback"
                      v-if="errors.fromAgeModel.error"
                    >
                      <span class="icon-error">!</span>
                      {{ errors.fromAgeModel.msg }}
                    </div>
                  </div>
                  <div
                    class="col-xs-4 d-flex flex-column "
                    style="align-items:flex-end"
                  >
                    <div class="d-flex" style="align-items:flex-end">
                      <span class="age-text me-2">〜</span>
                      <input
                        type="number"
                        class="form-control ageInc-field"
                        v-model="toAgeModel"
                        min="0"
                        v-bind:class="{ 'is-invalid': errors.toAgeModel.error }"
                      />
                      <span class="age-text">歳</span>
                    </div>
                    <div
                      class="invalid-feedback"
                      v-if="errors.toAgeModel.error"
                    >
                      <span class="icon-error">!</span>
                      {{ errors.toAgeModel.msg }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <h3 class="col-md-2 col-form-label">年収</h3>
              <div class="col-md-5">
                <div class="form-check form-check-inline">
                  <div class="col-xs-4 d-flex flex-column">
                    <div class="d-flex" style="align-items:flex-end">
                      <input
                        type="number"
                        class="form-control ageInc-field"
                        v-model="fromIncomeModel"
                        min="0"
                        v-bind:class="{
                          'is-invalid': errors.fromIncomeModel.error,
                        }"
                      />
                      <span class="income-text">万円</span>
                    </div>
                    <div
                      class="invalid-feedback"
                      v-if="errors.fromIncomeModel.error"
                    >
                      <span class="icon-error">!</span>
                      {{ errors.fromIncomeModel.msg }}
                    </div>
                  </div>
                  <div
                    class="col-xs-4 d-flex flex-column"
                    style="align-items:flex-end"
                  >
                    <div class="d-flex" style="align-items:flex-end">
                      <span class="income-text me-2">〜</span>
                      <input
                        type="number"
                        class="form-control ageInc-field"
                        v-model="toIncomeModel"
                        min="0"
                        v-bind:class="{
                          'is-invalid': errors.toIncomeModel.error,
                        }"
                      />
                      <span class="income-text">万円</span>
                    </div>
                    <div
                      class="invalid-feedback"
                      v-if="errors.toIncomeModel.error"
                    >
                      <span class="icon-error">!</span>
                      {{ errors.toIncomeModel.msg }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row mt-2">
              <h3 class="col-sm-2 col-form-label">学歴</h3>
              <div
                class="col-md-8 mt-2"
                style="padding: 0px; margin-left: 35px;"
              >
                <div class="row">
                  <div
                    class="col-md-4 search-checkbox"
                    v-for="finalEducation in jdSelectors.finalEducations"
                  >
                    <input
                      type="checkbox"
                      :id="finalEducation.id"
                      :value="finalEducation.id"
                      class="form-check-input"
                      v-model="finalEducationModel"
                    />
                    <label :for="finalEducation.id" class="form-check-label">
                      {{ finalEducation.title }}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row mt-2">
              <h3 class="col-sm-2 col-form-label">英語力</h3>
              <div class="col-md-9 mt-2" style="padding: 0px; margin-left: 35px;">
                <div class="english-skills-flex">
                  <div
                    class="english-skill-item"
                    v-for="englishSkill in jdSelectors.englishSkills"
                    :key="englishSkill.id"
                  >
                    <input
                      type="checkbox"
                      :id="englishSkill.id"
                      :value="englishSkill.id"
                      class="form-check-input"
                      v-model="englishSkillModel"
                    />
                    <label :for="englishSkill.id" class="form-check-label">
                      {{ englishSkill.title }}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row mt-2">
              <h3 class="col-md-2 col-form-label pt-0">直近職種</h3>
              <div class="col-md-5 mt-1">
                <a
                  v-on:click="toggleJobClassification('toggle')"
                  href="javascript:void(0)"
                  :class="hasJobsSelected ? 'job-selected-badge' : 'job-select-link'"
                >
                  {{ hasJobsSelected ? '選択中' : '+選択' }}
                </a>
                <b-modal
                  modal-class="custom-inner-modal"
                  id="jobClassification"
                  ref="jobClassificationModal"
                  hide-header
                  hide-footer
                  :no-close-on-esc="true"
                  :no-close-on-backdrop="true"
                  size="huge"
                >
                  <div
                    class="form-group row"
                    style="max-height: 500px;overflow-y:auto"
                  >
                    <div class="col-md-12">
                      <div
                        class="ps-4 search-checkbox"
                        v-for="main in jdSelectors.occupations"
                        v-bind:key="main.id"
                      >
                        <input
                          type="checkbox"
                          :id="main.id"
                          :value="main.id"
                          class="form-check-input"
                          v-model="mainJobModel"
                          @click="
                            watchParentJobUncheck(
                              $event,
                              'label' + main.id,
                              main
                            )
                          "
                        />
                        <label
                          :id="'label' + main.id"
                          @click="setLabelClicked"
                          class="form-check-label job-label"
                        >
                          {{ main.title }}
                        </label>
                        <div
                          class="row"
                          v-if="
                            isChecked(main.id) ||
                              isLabelClicked('label' + main.id)
                          "
                        >
                          <div
                            class="col-sm-6 search-checkbox"
                            v-for="child in main.children"
                            v-bind:key="child._id"
                          >
                            <div class="form-check form-check-inline">
                              <input
                                type="checkbox"
                                :id="child._id"
                                :value="child._id"
                                class="form-check-input"
                                v-model="childJobModel"
                                @click="manuallyCheckJob($event, main)"
                              />
                              <label :for="child._id" class="form-check-label">
                                {{ child.title }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer custom-footer">
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-danger jobBtn "
                      data-dismiss="modal"
                      @click="toggleJobClassification('cancel')"
                    >
                      キャンセル
                    </button>
                    <button
                      type="submit"
                      id="download"
                      class="btn btn-sm btn-primary jobBtn"
                      @click="toggleJobClassification('submit')"
                    >
                      保存
                    </button>
                  </div>
                </b-modal>
              </div>
            </div>

            <div class="form-group row mt-2">
              <h3 class="col-sm-2 col-form-label">ステータス</h3>
              <div
                class="col-md-8 mt-2"
                style="padding: 0px; margin-left: 15px;"
              >
                <div class="row">
                  <div
                    class="col-md-4 search-checkbox"
                    v-for="(status, index) in getJdClientStatus"
                    v-bind:key="index"
                  >
                    <div class="form-check form-check-inline">
                      <input
                        type="checkbox"
                        :id="index"
                        :value="status"
                        class="form-check-input"
                        v-model="statusModel"
                      />
                      <label :for="index" class="form-check-label">{{
                        status
                      }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div
          class="modal-footer d-flex justify-content-end"
          style="gap: 20px"
        >
          <button
            type="button"
            class="btn btn-outline-danger search-btn-block btn-white"
            data-dismiss="modal"
            @click="hideModal"
          >
            キャンセル
          </button>
          <button
            type="submit"
            id="download"
            class="btn btn-primary search-btn-block btn-teal"
            @click="handleSearch"
          >
            設定する
          </button>
          <button
            type="button"
            class="btn btn-secondary search-btn-block btn-gray"
            @click="clearAllSearches"
          >
            設定クリア
          </button>
        </div>
      </b-modal>
    </div>
  </section>
</template>

<script>
import vuejsDatepicker from 'vuejs-datepicker';
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import moment from 'moment';

export default {
  name: 'UserFilterSearch',
  components: {
    vuejsDatepicker,
  },
  data() {
    return {
      showFilterForm: false,
      errors: {
        fromAgeModel: {
          error: false,
          msg: '',
        },
        toAgeModel: {
          error: false,
          msg: '',
        },
        fromIncomeModel: {
          error: false,
          msg: '',
        },
        toIncomeModel: {
          error: false,
          msg: '',
        },
      },
      tempChildJobs: [],
      tempMainJobs: [],
      manuallyCheckedJobs: [],
      mainClicked: [],
      clickedLabels: [],
      registrationFromDate: null,
    };
  },
  computed: {
    ...mapState({
      jdSelectors: ({ jd }) => jd.jdSelectors,
    }),
    ...mapGetters({
      getJdClientStatus: 'jd/getJdClientStatus',
      getChildJobModel: 'jd/getChildJobModel',
      getMainJobModel: 'jd/getMainJobModel',
      getEnglishSkillModel: 'jd/getEnglishSkillModel',
      getFinalEducationModel: 'jd/getFinalEducationModel',
      getStatusModel: 'jd/getStatusModel',
      getSelectedDateRange: 'jd/getSelectedDateRange',
      getFromAgeModel: 'jd/getFromAgeModel',
      getToAgeModel: 'jd/getToAgeModel',
      getFromIncomeModel: 'jd/getFromIncomeModel',
      getToIncomeModel: 'jd/getToIncomeModel',
    }),
    selectedDateRange: {
      get() {
        return this.getSelectedDateRange;
      },
      set(value) {
        this.setSelectedDateRange(value);
      },
    },
    fromAgeModel: {
      get() {
        return this.getFromAgeModel;
      },
      set(value) {
        this.setFromAgeModel(value);
      },
    },
    toAgeModel: {
      get() {
        return this.getToAgeModel;
      },
      set(value) {
        this.setToAgeModel(value);
      },
    },
    fromIncomeModel: {
      get() {
        return this.getFromIncomeModel;
      },
      set(value) {
        this.setFromIncomeModel(value);
      },
    },
    toIncomeModel: {
      get() {
        return this.getToIncomeModel;
      },
      set(value) {
        this.setToIncomeModel(value);
      },
    },
    mainJobModel: {
      get() {
        return this.getMainJobModel;
      },
      set(value) {
        this.setMainJobModel(value);
      },
    },
    childJobModel: {
      get() {
        return this.getChildJobModel;
      },
      set(value) {
        this.setChildJobModel(value);
      },
    },
    finalEducationModel: {
      get() {
        return this.getFinalEducationModel;
      },
      set(value) {
        this.setFinalEducationModel(value);
      },
    },
    englishSkillModel: {
      get() {
        return this.getEnglishSkillModel;
      },
      set(value) {
        this.setEnglishSkillModel(value);
      },
    },
    statusModel: {
      get() {
        return this.getStatusModel;
      },
      set(value) {
        this.setStatusModel(value);
      },
    },
    hasJobsSelected() {
      return this.getMainJobModel.length > 0 || this.getChildJobModel.length > 0;
    },
    hasActiveSearch() {
      return (
        this.selectedDateRange ||
        this.fromAgeModel ||
        this.toAgeModel ||
        this.fromIncomeModel ||
        this.toIncomeModel ||
        this.finalEducationModel.length > 0 ||
        this.englishSkillModel.length > 0 ||
        this.statusModel.length > 0 ||
        this.hasJobsSelected
      );
    },
  },
  methods: {
    ...mapActions({
      loadJdSelectors: 'jd/loadJdSelectors',
    }),
    ...mapMutations({
      setChildJobModel: 'jd/setChildJobModel',
      setMainJobModel: 'jd/setMainJobModel',
      setEnglishSkillModel: 'jd/setEnglishSkillModel',
      setFinalEducationModel: 'jd/setFinalEducationModel',
      setStatusModel: 'jd/setStatusModel',
      setManuallyCheckedJobs: 'jd/setManuallyCheckedJobs',
      setSelectedDateRange: 'jd/setSelectedDateRange',
      setFromAgeModel: 'jd/setFromAgeModel',
      setToAgeModel: 'jd/setToAgeModel',
      setFromIncomeModel: 'jd/setFromIncomeModel',
      setToIncomeModel: 'jd/setToIncomeModel',
    }),
    toggleFilterForm() {
      this.$refs.filterForm.show();
    },
    hideModal() {
      this.$refs.filterForm.hide();
    },
    toggleJobClassification(action) {
      switch (action) {
        case 'toggle':
          this.tempChildJobs = [...this.childJobModel];
          this.tempMainJobs = [...this.mainJobModel];
          this.$refs.jobClassificationModal.show();
          break;
        case 'cancel':
          this.childJobModel = [...this.tempChildJobs];
          this.mainJobModel = [...this.tempMainJobs];
          this.$refs.jobClassificationModal.hide();
          break;
        case 'submit':
          this.$refs.jobClassificationModal.hide();
          break;
      }
    },
    isChecked(id) {
      if (this.mainJobModel.indexOf(id) !== -1) return true;
      return false;
    },
    isLabelClicked(id) {
      return this.clickedLabels.indexOf(id) !== -1;
    },
    setLabelClicked(event) {
      let index = this.clickedLabels.indexOf(event.target.id);
      if (index !== -1) {
        this.clickedLabels.splice(index, 1);
      } else {
        this.clickedLabels.push(event.target.id);
      }
    },
    watchParentJobUncheck(event, id, main) {
      let index = this.clickedLabels.indexOf(id);
      let mainIndexId = id.replace('label', '');
      let mainIndex = this.mainClicked.indexOf(mainIndexId);
      mainIndex === -1 && this.mainClicked.push(main.id);
      if (event.target.checked) {
        main.children.forEach((child) => this.childJobModel.push(child._id));
      } else {
        if (index !== -1) {
          this.clickedLabels.splice(index, 1);
        }
        if (mainIndex !== -1) {
          let removed = this.mainClicked.filter((item) => item != mainIndexId);
          this.mainClicked = [...removed];
        }
        const main = this.jdSelectors.occupations.find(
          (occ) => mainIndexId === occ.id
        );
        main.children.forEach((child) => {
          const index = this.childJobModel.indexOf(child._id);
          if (index !== -1) {
            const newChildJobModel = [...this.childJobModel];
            const newManuallyCheckedJobs = [...this.manuallyCheckedJobs];
            newChildJobModel.splice(index, 1);
            newManuallyCheckedJobs.splice(index, 1);
            // Update the state properties with the new arrays
            this.childJobModel = newChildJobModel;
            this.setManuallyCheckedJobs(newManuallyCheckedJobs);
            this.setManuallyCheckedJobs(
              Array.from(new Set(this.manuallyCheckedJobs))
            );
          }
        });
      }
      this.childJobModel = Array.from(new Set(this.childJobModel));
    },
    manuallyCheckJob(event, main) {
      if (event.target.checked) {
        this.manuallyCheckedJobs.push(event.target.id);
        this.childJobModel.push(event.target.id);
        !this.mainClicked.includes(main.id) && this.mainClicked.push(main.id);
      } else {
        let index = this.manuallyCheckedJobs.indexOf(event.target.id);
        let childIndex = this.childJobModel.indexOf(event.target.id);
        const newChildJobModel = [...this.childJobModel];
        newChildJobModel.splice(childIndex, 1);
        this.childJobModel = newChildJobModel;
        if (index !== -1) {
          const newManuallyCheckedJobs = [...this.manuallyCheckedJobs];
          // const newChildJobModel = [...this.childJobModel];
          // newChildJobModel.splice(index, 1);
          newManuallyCheckedJobs.splice(index, 1);
          this.setManuallyCheckedJobs(newManuallyCheckedJobs);
          // this.childJobModel = newChildJobModel;
          // console.log(this.childJobModel);
          //   this.mainClicked.splice(mainIndex,1);
        }
      }
      let x = this.checkChildCount(main);
      if (x.childCount < 1) {
        let mainJob = this.mainJobModel.indexOf(main.id);
        let mainIndex = this.mainClicked.indexOf(main.id);
        //   let clickedLabelIndex = this.clickedLabels.indexOf(`label${main.id}`);
        this.clickedLabels = this.clickedLabels.filter(
          (item) => item !== `label${main.id}`
        );
        this.mainClicked.splice(mainIndex, 1);
        console.log(mainJob);
        if (mainJob !== -1) {
          this.mainJobModel.splice(mainJob, 1);
        }
        // if(mainIndex !== -1){
        //     let removed = this.mainClicked.filter((item)=> item != main.id);
        //     this.mainClicked = [...removed]
        // }
      }
    },
    checkChildCount(main) {
      let children = main.children.length;
      let childCount = 0;
      for (let i = 0; i < main.children.length; i++) {
        for (let j = 0; j < this.childJobModel.length; j++) {
          // console.log('here');
          if (main.children[i]._id == this.childJobModel[j]) {
            childCount++;
          }
        }
      }
      let childCounts = {
        children,
        childCount,
      };
      return childCounts;
    },
    handleDateRangeChange() {
      let fromDate = null;
      const toDate = new Date();

      switch (this.selectedDateRange) {
        case '1week':
          fromDate = moment()
            .subtract(1, 'weeks')
            .toDate();
          break;
        case '2weeks':
          fromDate = moment()
            .subtract(2, 'weeks')
            .toDate();
          break;
        case '1month':
          fromDate = moment()
            .subtract(1, 'months')
            .toDate();
          break;
        case '2months':
          fromDate = moment()
            .subtract(2, 'months')
            .toDate();
          break;
        default:
          fromDate = null;
      }
      this.setSelectedDateRange(fromDate);
    },
    handleSearch() {
      // Implement search logic
      this.$refs.filterForm.hide();
    },
    clearAllSearches() {
      // Clear all search filters
      this.selectedDateRange = '';
      this.fromAgeModel = '';
      this.toAgeModel = '';
      this.fromIncomeModel = '';
      this.toIncomeModel = '';
      this.finalEducationModel = [];
      this.englishSkillModel = [];
      this.statusModel = [];
      this.mainJobModel = [];
      this.childJobModel = [];
      this.manuallyCheckedJobs = [];
      this.mainClicked = [];
      this.clickedLabels = [];
    },
  },
  async created() {
    await this.loadJdSelectors();
  },
};
</script>

<style scoped>

.btn-blue {
  background-color: #036D6C;
  color: #fff;
  border-color: #036D6C;
  border-radius: 4px;
  transition: opacity 0.2s ease-in-out;
}

.btn-blue:hover {
  opacity: 0.6;
  background-color: #036D6C !important;
}
.search-btn-block {
  font-weight: bold;
}
.english-skills-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  width: 80% !important;
}

/* .english-skill-item {
  display: flex;
  align-items: center;
  min-width: 0;
} */

/* Job selection styling */
.job-select-link {
  color: #3c3c3c;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
}

.job-selected-badge {
  color: #006C6B;
  background-color: transparent;
  border: 3px solid #006C6B;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  display: inline-block;
}

.job-selected-badge:hover {
  text-decoration: none;
  background-color: rgba(32, 178, 170, 0.1);
}

/* AI Settings active styling */
.ai-settings-active {
  color: #006C6B !important;
  background-color: transparent;
  border: 3px solid #006C6B;
  border-radius: 20px;
  padding: 4px 12px;
  font-weight: bold;
  display: inline-block;
}

.english-skill-item label {
  margin-left: 5px;
  white-space: nowrap;
  font-weight: 400 !important;
}

@media (min-width: 992px) {
  >>>.modal-lg {
    max-width: 960px !important;
  }
}
label {
  cursor: pointer;
}
.search-checkbox label {
  font-weight: normal !important;
  font-size: 14px !important;
}
.col-form-label {
  font-weight: bold !important;
}
.age-text {
  margin: 0 5px;
  width: 20px;
  color: #3c3c3c;
  font-size: 14px;
}
.income-text {
  width: 40px;
  color: #3c3c3c;
  font-size: 14px;
}
.ageInc-field {
  width: 100px;
}
.jobBtn {
  border-radius: 4px;
  padding: 10px;
  font-size: 14px;
}
h3 {
  color: #3c3c3c;
  font-size: 14px;
}
.custom-form-block .form-control {
  border-bottom: 1px solid #b3b3b3 !important;
}
</style>
